import { FC, useState, useEffect, ChangeEvent } from 'react';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { consentsActions } from 'store/consents/consentsSlice';
import { selectConsents, selectFilter } from 'store/consents/consentsSelectors';
// Components
import { Input } from 'components/Controls';
// i18next
import { useTranslation } from 'react-i18next';

let timeout:any = null;

const ConsentsFilter:FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const consents = useAppSelector(selectConsents);
  const filter = useAppSelector(selectFilter);

  const [ stateFilter, setStateFilter ] = useState(filter);

  useEffect(() => {
    return () => {
      if ( timeout ) clearTimeout(timeout);
      dispatch(consentsActions.setInitialField('filter'));
    }
    // eslint-disable-next-line
  }, []);

  const handleChange = (event:ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setStateFilter(prevState => ({ ...prevState, [name]: value }));
    if ( timeout ) clearTimeout(timeout);
    timeout = setTimeout(() => {
      dispatch(consentsActions.setFilter({ [name]: value }));
    }, 1000);
  }

  if ( !consents || consents.length === 0 ) return null;
  return (
    <Input
      className="mb-0"
      id="search" name="search" value={stateFilter.search} placeholder={t('labels.search')}
      onChange={handleChange}
    />
  )
}

export default ConsentsFilter;
